module.exports = __webpack_public_path__ + "static/consume-8707565532716246f0efbbd7780714f2.png";